import { Link, Typography } from "@mui/material";
import React, { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useIsMobile } from "shared-ts-utils-ua-parser";
import { If } from "shared-ts-ui-react";

export const DeliveredByAirmont: FC = () => {
  const { t } = useTranslation("my-chimney-ts-translations");
  const isMobile = useIsMobile();

  return (
    <Typography textAlign={"center"} color={"text.secondary"}>
      <If
        expression={isMobile}
        then={t("This is an application delivered by airMont AS")}
        else={
          <Trans
            i18nKey={"This is an application delivered by airMont AS:Link"}
            ns={"my-chimney-ts-translations"}
            components={{
              Link: <Link href={"https://www.airmont.no"} target={"_blank"} />,
            }}
          />
        }
      >
        <br />
      </If>
      .
    </Typography>
  );
};
